export type ProposalDiffChange = {
  field: string;
  before: unknown;
  after: unknown;
};

export type ProposalDiff = {
  productId?: number;
  productTitle?: string;
  clientId?: number;
  clientEmail?: string;
  mode?: string;
  quantity?: number;
  before?: Record<string, unknown>;
  after?: Record<string, unknown>;
  changes?: ProposalDiffChange[];
  previewType?:
    | "newsletter"
    | "linkedin"
    | "marketing_campaign"
    | "create_product"
    | "create_client"
    | "delete_product"
    | "delete_client"
    | "update_inventory";
  subject?: string;
  bodyPreview?: string;
  textPreview?: string;
  text?: string;
  campaignName?: string;
  objective?: string;
  targetAudience?: string;
  platforms?: string[];
  keyMessage?: string;
  previews?: Array<{ platform: string; subject?: string; preview?: string }>;
  content?: Record<string, unknown>;
  plan?: Record<string, unknown>;
};

export type BusinessProposal = {
  id: string;
  userBusinessId?: number;
  conversationId?: string | null;
  messageId?: string | null;
  type: string;
  status: "pending" | "approved" | "rejected" | "expired" | "superseded";
  summary: string;
  diff: ProposalDiff;
  executionPlan?: Record<string, unknown>;
  resolvedAt?: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export type ProposalEnvelopeDraft = Omit<BusinessProposal, "id" | "status"> & {
  id?: string;
  status?: BusinessProposal["status"];
};

export function isValidProposalId(value: unknown): value is string {
  return (
    typeof value === "string" &&
    value.length > 0 &&
    value !== "undefined" &&
    value !== "null"
  );
}
